import { useQuery } from 'react-query';

import { getTechnicianToObject } from 'api/clients/getTechnicianToObject';

export const useGetTechnicianToObject = (objectSlug?: string) => {
  const enabled = objectSlug !== undefined;

  const { data, refetch, isLoading, isRefetching } = useQuery(
    ['techniciansToAddOnObject', objectSlug],
    () => getTechnicianToObject(objectSlug as string),
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading, isRefetching };
};

export default useGetTechnicianToObject;
